import * as React from 'react';
import ReactSelect from 'react-select';
import ErrorHint from '../common/ErrorHint';
import { BaseInputProps } from './BaseInput';
import FieldDescription from '../common/FieldDescription';
import {
  Choice,
  getCustomStyles,
  getErrorStyles,
  isDarkMode,
  isChoice,
} from './SelectCommon';
import { FieldLabel } from './FieldLabel';
import { DeviceData } from '../../common/deviceData';

interface SelectProps extends BaseInputProps<string | number> {
  choices: Choice[];
  hideLabel?: boolean;
  placeholder?: string;
  isSearchable?: boolean;
  isRequired: boolean;
  menuInPortal?: boolean;
}

export const Select: React.FC<SelectProps> = ({
  choices,
  title,
  description,
  value,
  updateHandler,
  blurHandler,
  error,
  hideLabel = false,
  placeholder = '',
  isSearchable = false,
  isRequired,
  menuInPortal = false,
}: SelectProps) => {
  const selectedValue =
    choices.find((choise) => choise.value === value) || null;
  const usePortal = menuInPortal || DeviceData.isMobileBrowser();

  return (
    <div className="w-full">
      {!hideLabel && <FieldLabel text={title} isRequired={isRequired} />}
      <div className="w-full my-2">
        <ReactSelect
          id={title}
          name={title}
          placeholder={placeholder || ''}
          value={selectedValue}
          options={choices}
          getOptionLabel={(item: Choice) => item.title?.toString() ?? ''}
          getOptionValue={(item: Choice) => item.value?.toString() ?? ''}
          styles={
            error ? getErrorStyles(isDarkMode()) : getCustomStyles(isDarkMode())
          }
          isSearchable={isSearchable}
          isClearable
          // blurInputOnSelect (triggers autosave prematurely)
          closeMenuOnSelect
          onChange={(option) => {
            const newVal = isChoice(option) ? option.value : null;
            updateHandler(newVal);
          }}
          onBlur={(e) => {
            blurHandler(e);
          }}
          menuPlacement="auto"
          menuPortalTarget={usePortal ? document.body : undefined}
          menuPosition={usePortal ? 'fixed' : undefined}
        />
      </div>
      <ErrorHint error={error} />
      <FieldDescription description={description} />
    </div>
  );
};
